















import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import TPPClaimsModule from "@/store/modules/tpp-claims";
import { TPPClaimsState } from "@/models/store/TPPClaimsState";
import TPPClaimsTable from "@/views/tpp-claims/partials/TPPClaimsTable.vue";

const tppClaims = namespace(TPPClaimsModule.name);

@Component({
  name: "TPPClaimsIndex",
  components: { ApplicationLayout, TPPClaimsTable }
})
export default class TPPClaimsIndex extends Vue {
  // ===== Props ===== //

  // ===== Store ===== //
  @State("tppClaims") private readonly tppClaims!: TPPClaimsState;
  @tppClaims.Action("getClaimStatuses") public getClaimStatuses!: () => void;
  @tppClaims.Action("getLossTypes") public getLossTypes!: () => void;

  // ===== Data ===== //

  // ===== Methods ===== //

  // ===== Computed ===== //

  // ===== Lifecycle ===== //

  private created(): void {
    if (this.tppClaims.lossTypesList && !this.tppClaims.lossTypesList.length) {
      this.getLossTypes();
    }
    if (this.tppClaims.claimStatusesList && !this.tppClaims.claimStatusesList.length) {
      this.getClaimStatuses();
    }
  }
}
